export enum PermissionPrefixKey {
  DEVICE = 'device',
  MOBILE = 'mobile',
  GEOFENCE = 'geofence',
  POSITION = 'position',
  CONSOLIDATE = 'consolidate',
  ACTIVITY = 'activity',
  ALARM = 'alarm',
  PROPERTY = 'property',
  SIM_CARD = 'sim-card',
  CHOICE = 'choice',
  CURRENT_MOBILE = 'current-mobile',
  PROFILE = 'profile',
  CONTACT = 'contact',
  USER = 'user',
  PERMISSION = 'permission',
  MAINTENANCE = 'maintenance',
  LANGUAGE = 'language',
  HARDWARE = 'hardware'
}

export enum PermissionSuffixKey{
  LIST = 'list',
  CREATE  = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
  COMMAND = 'command',
  RESELLER = 'reseller',
  CALCULATE = 'calc',
  CONFIG = 'config',
  JOIN = 'JOIN',
}
export enum PermissionKey {

  // Device
  DEVICE_LIST = `${PermissionPrefixKey.DEVICE}:${PermissionSuffixKey.LIST}`,
  DEVICE_CREATE = `${PermissionPrefixKey.DEVICE}:${PermissionSuffixKey.CREATE}`,
  DEVICE_UPDATE = `${PermissionPrefixKey.DEVICE}:${PermissionSuffixKey.UPDATE}`,
  DEVICE_DELETE = `${PermissionPrefixKey.DEVICE}:${PermissionSuffixKey.DELETE}`,
  DEVICE_COMMAND = `${PermissionPrefixKey.DEVICE}:${PermissionSuffixKey.COMMAND}`,

  // Mobile
  MOBILE_LIST = `${PermissionPrefixKey.MOBILE}:${PermissionSuffixKey.LIST}`,
  MOBILE_CREATE = `${PermissionPrefixKey.MOBILE}:${PermissionSuffixKey.CREATE}`,
  MOBILE_CONFIG = `${PermissionPrefixKey.MOBILE}:${PermissionSuffixKey.CONFIG}`,
  MOBILE_UPDATE = `${PermissionPrefixKey.MOBILE}:${PermissionSuffixKey.UPDATE}`,
  MOBILE_DELETE = `${PermissionPrefixKey.MOBILE}:${PermissionSuffixKey.DELETE}`,
  MOBILE_COMMAND = `${PermissionPrefixKey.MOBILE}:${PermissionSuffixKey.COMMAND}`,

  // Geofence
  GEOFENCE_LIST = `${PermissionPrefixKey.GEOFENCE}:${PermissionSuffixKey.LIST}`,
  GEOFENCE_CREATE = `${PermissionPrefixKey.GEOFENCE}::${PermissionSuffixKey.CREATE}`,
  GEOFENCE_UPDATE = `${PermissionPrefixKey.GEOFENCE}:${PermissionSuffixKey.UPDATE}`,
  GEOFENCE_DELETE = `${PermissionPrefixKey.GEOFENCE}:${PermissionSuffixKey.DELETE}`,

  // Position
  POSITION_LIST = `${PermissionPrefixKey.POSITION}:${PermissionSuffixKey.LIST}`,
  POSITION_DELETE = `${PermissionPrefixKey.POSITION}:${PermissionSuffixKey.DELETE}`,

  CONSOLIDATE_LIST = `${PermissionPrefixKey.CONSOLIDATE}:${PermissionSuffixKey.LIST}`,
  CONSOLIDATE_CALC = `${PermissionPrefixKey.CONSOLIDATE}:${PermissionSuffixKey.CALCULATE}`,

  ACTIVITY_LIST = `${PermissionPrefixKey.ACTIVITY}:${PermissionSuffixKey.LIST}`,
  ACTIVITY_CALC = `${PermissionPrefixKey.ACTIVITY}:${PermissionSuffixKey.CALCULATE}`,


  ALARM_LIST = `${PermissionPrefixKey.ALARM}:${PermissionSuffixKey.LIST}`,
  ALARM_DELETE = `${PermissionPrefixKey.ALARM}:${PermissionSuffixKey.DELETE}`,

  // Property
  PROPERTY_LIST = `${PermissionPrefixKey.PROPERTY}:${PermissionSuffixKey.LIST}`,
  PROPERTY_CREATE = `${PermissionPrefixKey.PROPERTY}::${PermissionSuffixKey.CREATE}`,
  PROPERTY_UPDATE = `${PermissionPrefixKey.PROPERTY}:${PermissionSuffixKey.UPDATE}`,
  PROPERTY_DELETE = `${PermissionPrefixKey.PROPERTY}:${PermissionSuffixKey.DELETE}`,
  PROPERTY_RESELLER = `${PermissionPrefixKey.PROPERTY}:${PermissionSuffixKey.RESELLER}`,

  // SIM Card
  SIM_CARD_LIST = `${PermissionPrefixKey.SIM_CARD}:${PermissionSuffixKey.LIST}`,
  SIM_CARD_CREATE = `${PermissionPrefixKey.SIM_CARD}::${PermissionSuffixKey.CREATE}`,
  SIM_CARD_UPDATE = `${PermissionPrefixKey.SIM_CARD}:${PermissionSuffixKey.UPDATE}`,
  SIM_CARD_DELETE = `${PermissionPrefixKey.SIM_CARD}:${PermissionSuffixKey.DELETE}`,

  // Choice
  CHOICE_LIST = `${PermissionPrefixKey.CHOICE}:${PermissionSuffixKey.LIST}`,
  CHOICE_CREATE = `${PermissionPrefixKey.CHOICE}::${PermissionSuffixKey.CREATE}`,
  CHOICE_UPDATE = `${PermissionPrefixKey.CHOICE}:${PermissionSuffixKey.UPDATE}`,
  CHOICE_DELETE = `${PermissionPrefixKey.CHOICE}:${PermissionSuffixKey.DELETE}`,

  // Current Mobile
  CURRENT_MOBILE_LIST = `${PermissionPrefixKey.CURRENT_MOBILE}:${PermissionSuffixKey.LIST}`,
  CURRENT_MOBILE_DELETE = `${PermissionPrefixKey.CURRENT_MOBILE}:${PermissionSuffixKey.DELETE}`,

  // Profile
  PROFILE_LIST = `${PermissionPrefixKey.PROFILE}:${PermissionSuffixKey.LIST}`,
  PROFILE_CREATE = `${PermissionPrefixKey.PROFILE}::${PermissionSuffixKey.CREATE}`,
  PROFILE_UPDATE = `${PermissionPrefixKey.PROFILE}:${PermissionSuffixKey.UPDATE}`,
  PROFILE_DELETE = `${PermissionPrefixKey.PROFILE}:${PermissionSuffixKey.DELETE}`,

  // Contact
  CONTACT_LIST = `${PermissionPrefixKey.CONTACT}:${PermissionSuffixKey.LIST}`,
  CONTACT_CREATE = `${PermissionPrefixKey.CONTACT}::${PermissionSuffixKey.CREATE}`,
  CONTACT_UPDATE = `${PermissionPrefixKey.CONTACT}:${PermissionSuffixKey.UPDATE}`,
  CONTACT_DELETE = `${PermissionPrefixKey.CONTACT}:${PermissionSuffixKey.DELETE}`,

  // User
  USER_LIST = `${PermissionPrefixKey.USER}:${PermissionSuffixKey.LIST}`,
  USER_JOIN = `${PermissionPrefixKey.USER}:${PermissionSuffixKey.JOIN}`,
  USER_UPDATE = `${PermissionPrefixKey.USER}:${PermissionSuffixKey.UPDATE}`,
  USER_DELETE = `${PermissionPrefixKey.USER}:${PermissionSuffixKey.DELETE}`,

  // Permission
  PERMISSION_LIST = `${PermissionPrefixKey.PERMISSION}:${PermissionSuffixKey.LIST}`,
  PERMISSION_UPDATE = `${PermissionPrefixKey.PERMISSION}:${PermissionSuffixKey.UPDATE}`,

  // Language
  LANGUAGE_LIST = `${PermissionPrefixKey.LANGUAGE}:${PermissionSuffixKey.LIST}`,
  LANGUAGE_CREATE = `${PermissionPrefixKey.LANGUAGE}::${PermissionSuffixKey.CREATE}`,
  LANGUAGE_UPDATE = `${PermissionPrefixKey.LANGUAGE}:${PermissionSuffixKey.UPDATE}`,
  LANGUAGE_DELETE = `${PermissionPrefixKey.LANGUAGE}:${PermissionSuffixKey.DELETE}`,

  // Maintenance
  MAINTENANCE_LIST = `${PermissionPrefixKey.MAINTENANCE}:${PermissionSuffixKey.LIST}`,
  MAINTENANCE_CREATE = `${PermissionPrefixKey.MAINTENANCE}::${PermissionSuffixKey.CREATE}`,
  MAINTENANCE_UPDATE = `${PermissionPrefixKey.MAINTENANCE}:${PermissionSuffixKey.UPDATE}`,
  MAINTENANCE_DELETE = `${PermissionPrefixKey.MAINTENANCE}:${PermissionSuffixKey.DELETE}`,

  HARDWARE_LIST = `${PermissionPrefixKey.HARDWARE}:${PermissionSuffixKey.LIST}`,
  HARDWARE_CREATE = `${PermissionPrefixKey.HARDWARE}::${PermissionSuffixKey.CREATE}`,
  HARDWARE_UPDATE = `${PermissionPrefixKey.HARDWARE}:${PermissionSuffixKey.UPDATE}`,
  HARDWARE_DELETE = `${PermissionPrefixKey.HARDWARE}:${PermissionSuffixKey.DELETE}`,

  ALL_ACCESS = 'all-access'
}
